<template>
    <div>
        <div ref="audioList" class="audio-list">

          <h1>Tondokumente</h1>
          <h3>Friedrich Dürrenmatt: Lesungen/Vorträge zu den <i>Stoffen</i></h3>
          <ul >
            <!--<li>Lesung <i>Dokument</i>, 1965 (Rundfunkaufnahme)</li>-->
            <li>Lesung <i>Stoffe</i>, Genf, 1974 (private Probeaufnahme)</li>
            <!--<li><i>Stoffe</i>-Lesung, Bern 1976 (Rundfunkaufnahme)</li>
            <li><i>Stoffe</i>-Vortrag (Kunst und Wissenschaft), Frankfurt am Main, 1984, Teil 1 und 2 (private Probeaufnahme)</li>-->
            <li>Lesung <i>Die Brücke</i> (aus <i>Prometheus</i>), Hannover, 1984 (Rundfunkaufnahme)</li>
            <!--<li>Lesung <i>Der Tod des Sokrates</i>, München, 1990 (Rundfunkaufnahme)</li> -->           
          </ul>
          <h3>Gespräche mit Friedrich Dürrenmatt</h3>
          <ul >
            <li>Aufnahme Peter André Bloch, Schuls, 1969</li>
            <li>Aufnahme Heinz Ludwig Arnold, Neuchâtel, 1975 </li>
            <li>Gespräch Arnold/Lehner, Neuchâtel, 1981</li>
            <!--<li>Aufnahme Arnold zum 60. Geburtstag 1981 </li> -->           
          </ul>
          <!-- <h3>Weiteres</h3>
          <ul >
            <li>Gespräch mit Thomas Bodmer über die Lektoratsarbeit an den Stoffen mit Dürrenmatt (3.5.2018, Fragen: Ulrich Weber)</li>            
          </ul> -->        
        </div>
    </div>
</template>

<script>


export default {
    name: "AudioList"

}
</script>

<style lang="scss" >
.audio-list {
  display: block;
  max-width: 600px;
  margin: 150px auto;
  ul {
    margin: 2rem 0;
    list-style: disc;
    li {
      display:block;
      padding: 5px 0;      
      text-align: left;
      font-size: 1.3rem;
    }
  }
}

</style>